import CheckUser from "../../utils/check-user"

$("input[type='submit']").click(function(e) {
    e.preventDefault();

    let userChecker = new CheckUser();

    if(userChecker.checkEmailInput()) {
        $('form').unbind('submit').submit();
    }
});


// WEBPACK FOOTER //
// ./assets/js/panel/login-system/panel-resetting-request.js